
import React, { useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { ProcurementFormValues } from "./schema";
import { SourceField } from "./fields/SourceField";
import { ItemsField } from "./fields/ItemsField";
import { ExpectedDeliveryDateField } from "./fields/ExpectedDeliveryDateField";
import { CostBreakdownFields } from "./fields/CostBreakdownFields";
import { PaymentTermsFields } from "./fields/PaymentTermsFields";
import { NotesField } from "./fields/NotesField";

interface ProcurementFormFieldsProps {
  form: UseFormReturn<ProcurementFormValues>;
}

export const ProcurementFormFields: React.FC<ProcurementFormFieldsProps> = ({ form }) => {
  const [itemsSubtotal, setItemsSubtotal] = useState<number>(0);

  return (
    <div className="space-y-8">
      <SourceField form={form} />
      <ItemsField form={form} subtotal={itemsSubtotal} />
      <ExpectedDeliveryDateField form={form} />
      <CostBreakdownFields form={form} onSubtotalChange={setItemsSubtotal} />
      <PaymentTermsFields form={form} />
      <NotesField form={form} />
    </div>
  );
};
